var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('generic-form-view',{attrs:{"rootPath":"/v2/online_scan","forms":_vm.forms,"columns":_vm.columns,"table_name":_vm.table_name},on:{"onSubmitted":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }